import { Product } from "./product";

export enum EchoProduct {
    PINNACLE_SMS = 'PINNACLE_SMS',
    PINNACLE_EMAIL = 'PINNACLE_EMAIL',
    PINNACLE_WHATSAPP = 'PINNACLE_WHATSAPP',
    PINNACLE_RCS = 'PINNACLE_RCS'
}

export enum EchoLanguage {
    ENGLISH = 'ENGLISH',
    HINDI = 'HINDI',
    MARATHI = 'MARATHI',
    BENGALI = 'BENGALI',
    PUNJABI = 'PUNJABI'
}

export enum EchoSpeaker {
    MALE = 'MALE',
    FEMALE = 'FEMALE'
}

export enum SortField {
    CREATED_AT = 'createdAt',
    NAME = 'name',
    PRODUCT = 'product',
    VALID_TILL = 'validTill'
}

export enum SortOrder {
    ASC = 'asc',
    DESC = 'desc'
}

export interface Audience {
    firstName: string;
    lastName: string;
    email: string;
}

export interface AudienceResponse extends Audience {
    id: string;
    createdAt: string;
    updatedAt: string;
}

export interface Echo {
    id: string;
    name: string;
    description: string;
    product?: Product;
    language: EchoLanguage;
    speaker: EchoSpeaker;
    validTill: string;
    createdAt: string;
    updatedAt: string;
    showAvatar?: boolean;
}

export interface Pagination {
    total: number;
    pages: number;
    currentPage: number;
    limit: number;
}

export interface GetEchosParams {
    page?: number;
    limit?: number;
    search?: string;
    sortBy?: SortField;
    sortOrder?: SortOrder;
}

export interface GetEchosResponse {
    success: boolean;
    message: string;
    data: {
        echos: Echo[];
        pagination: Pagination;
    };
}

export interface CreateEchoRequest {
    name: string;
    description: string;
    productId: string;
    language: EchoLanguage;
    speaker: EchoSpeaker;
    validTill: string;
    showAvatar: boolean;
    audiences: {
        firstName: string;
        lastName: string;
        email: string;
    }[];
}

export interface CreateEchoResponse {
    success: boolean;
    message: string;
    data?: {
        echo: Echo;
        audiences: AudienceResponse[];
    };
}

export interface ApiErrorResponse {
    success: false;
    message: string;
}

export interface EchoSessionAudience {
    firstName: string;
    lastName: string;
    email: string;
}

export interface EchoSession {
    id: string;
    echoId: string;
    audienceId: string;
    status: 'COMPLETED' | 'IN_PROGRESS' | 'PENDING';
    createdAt: string;
    updatedAt: string;
    audience: EchoSessionAudience;
}

export interface GetEchoSessionsParams {
    page?: number;
    limit?: number;
    search?: string;
    sortBy?: 'createdAt' | 'updatedAt';
    sortOrder?: 'asc' | 'desc';
}

export interface GetEchoSessionsResponse {
    success: boolean;
    message: string;
    data: {
        sessions: EchoSession[];
        pagination: {
            total: number;
            pages: number;
            currentPage: number;
            limit: number;
        };
    };
}